import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Flex } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import CrmImportHeader from "./components/CrmImportHeader";
import DataImport from "./components/DataImport";
import DataValidation from "./components/DataValidation";
import ImportProgress from "./components/ImportProgress";
import ProjectSetup from "./components/ProjectSetup";
import TestDataRelease from "./components/TestDataRelease";
import { CRM_IMPORT_BASE_ROUTE, WorkflowStep } from "./constants";
import { useIdQueryParam } from "./hooks/useIdQueryParam";
import * as styles from "./styles_vanilla.css";
import { getWorkflowRoute } from "./utils/workflowUtils";

const CrmImport: React.FC = () => {
  const { getQueryParamsWithId } = useIdQueryParam();

  return (
    <Flex
      data-testid="data-studio-crm-import"
      className={styles.pageContainer}
      flexDirection="column"
    >
      {/* Top section with header */}
      <CrmImportHeader />

      {/* Progress indicator */}
      <ImportProgress />

      {/* Main content area with routing */}
      <Flex className={styles.contentContainer}>
        <Switch>
          <Route exact path={getWorkflowRoute(WorkflowStep.PROJECT_SETUP)}>
            <ProjectSetup />
          </Route>
          <Route exact path={getWorkflowRoute(WorkflowStep.DATA_IMPORT)}>
            <DataImport />
          </Route>
          <Route exact path={getWorkflowRoute(WorkflowStep.DATA_VALIDATION)}>
            <DataValidation />
          </Route>
          <Route exact path={getWorkflowRoute(WorkflowStep.TEST_DATA_RELEASE)}>
            <TestDataRelease />
          </Route>
          <Route exact path={CRM_IMPORT_BASE_ROUTE}>
            <Redirect
              to={getWorkflowRoute(WorkflowStep.PROJECT_SETUP, getQueryParamsWithId())}
            />
          </Route>
          <Route path={CRM_IMPORT_BASE_ROUTE}>
            <Redirect to={globalEnv.dataStudioRoute} />
          </Route>
        </Switch>
      </Flex>
    </Flex>
  );
};

export default CrmImport;
